var _circle, _g, _circle2, _circle3, _circle4, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 81,
    viewBox: "0 0 97 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 27.5,
    r: 27.5,
    fill: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_403_8234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3106 8.12842C43.8533 8.12842 39.0259 10.8328 36.0882 14.978C35.1288 14.7511 34.1284 14.6311 33.1 14.6311C25.9378 14.6311 20.1316 20.4537 20.1316 27.6364C20.1316 34.819 25.9378 40.6417 33.1 40.6417L65.5211 40.6417C71.788 40.6417 76.8684 35.5468 76.8684 29.262C76.8684 22.9772 71.788 17.8824 65.5211 17.8824C65.0759 17.8824 64.6368 17.9081 64.205 17.9581C61.7209 12.1762 55.9871 8.12842 49.3106 8.12842Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1,
    cy: 27.6362,
    rx: 12.9684,
    ry: 13.0053,
    fill: "url(#paint0_linear_403_8234)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.3106,
    cy: 24.385,
    rx: 16.2105,
    ry: 16.2566,
    fill: "url(#paint1_linear_403_8234)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.521,
    cy: 29.262,
    rx: 11.3474,
    ry: 11.3796,
    fill: "url(#paint2_linear_403_8234)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.0715,
    cy: 60.5,
    r: 5.5,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 25.1431,
    r: 5.5,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.6429,
    cy: 3.9285,
    r: 3.14286,
    fill: "#F2F4F7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_403_8234)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.1428,
    y: 25.9287,
    width: 26.7143,
    height: 26.7143,
    rx: 13.3571,
    fill: "#344054",
    fillOpacity: 0.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_8234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9999 41.6665L48.4999 38.9998M48.4999 38.9998L45.9999 41.6665M48.4999 38.9998V44.9998M53.7437 43.2598C54.3533 42.9053 54.8348 42.3444 55.1123 41.6656C55.3899 40.9867 55.4475 40.2286 55.2763 39.511C55.105 38.7933 54.7146 38.1568 54.1666 37.7021C53.6186 37.2474 52.9442 37.0003 52.2499 36.9998H51.4624C51.2732 36.2193 50.9206 35.4947 50.4311 34.8805C49.9416 34.2663 49.3279 33.7784 48.6362 33.4536C47.9445 33.1287 47.1928 32.9754 46.4375 33.0051C45.6822 33.0348 44.9431 33.2467 44.2756 33.6249C43.6082 34.0032 43.0299 34.5379 42.5841 35.1889C42.1382 35.8399 41.8366 36.5902 41.7018 37.3834C41.567 38.1767 41.6025 38.9922 41.8057 39.7687C42.0089 40.5452 42.3744 41.2624 42.8749 41.8665",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_403_8234",
    x: 0.131592,
    y: 8.12842,
    width: 96.7368,
    height: 72.5132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_403_8234"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_403_8234"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_403_8234"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_403_8234",
    result: "effect2_dropShadow_403_8234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_403_8234",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_403_8234",
    x: 27.1428,
    y: 17.9287,
    width: 42.7144,
    height: 42.7144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_403_8234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_403_8234",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_8234",
    x1: 23.1421,
    y1: 19.0434,
    x2: 46.1295,
    y2: 40.5763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_403_8234",
    x1: 36.8633,
    y1: 13.6441,
    x2: 65.5974,
    y2: 40.5602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_403_8234",
    x1: 56.8078,
    y1: 21.7433,
    x2: 76.9217,
    y2: 40.5846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_8234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    fill: "white",
    transform: "translate(41 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.182c35892c986d03a4b6cb32fe34d55d.svg";
export { ForwardRef as ReactComponent };